module.exports = __webpack_public_path__ + "static/media/WheatStage101.3320bd3e.PNG";